(() => {
  const init = (root = document) => root.querySelectorAll('[data-uwx-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('[data-uwx-track]');
    const slides = [...track.children];
    const dots = [...gallery.querySelectorAll('[data-uwx-dot]')];
    const status = gallery.querySelector('[data-uwx-status]');
    let index = 0;
    let frame;
    const update = () => {
      index = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
      dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      status.textContent = `Image ${index + 1} of ${slides.length}`;
    };
    const go = i => {
      const next = (i + slides.length) % slides.length;
      track.scrollTo({left: track.clientWidth * next, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    };
    gallery.querySelector('[data-uwx-nav]').hidden = false;
    gallery.querySelector('[data-uwx-prev]').addEventListener('click', () => go(index - 1));
    gallery.querySelector('[data-uwx-next]').addEventListener('click', () => go(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive: true});
    track.addEventListener('keydown', event => {
      const keys = {ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: slides.length - 1};
      if (!(event.key in keys)) return;
      event.preventDefault(); go(keys[event.key]);
    });
    new ResizeObserver(() => { track.scrollTo({left: track.clientWidth * index, behavior: 'instant'}); }).observe(track);
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
